import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=77132090&scoped=true"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Investments.vue?vue&type=style&index=1&id=77132090&prod&lang=scss"
import style2 from "./Investments.vue?vue&type=style&index=2&id=77132090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77132090",
  null
  
)

export default component.exports